module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS7.9bf743dc.jpg";